document.addEventListener('DOMContentLoaded', () => {
    var CarouselSwiper = new Swiper('.card-carousel-middle', {
        slidesPerView: 2.6,
        spaceBetween: 16,
        navigation: {
          nextEl: '.card-carousel-next',
          prevEl: '.card-carousel-prev',
        },
        breakpoints: {
            769: { slidesPerView: 2.6 },
            300: { slidesPerView: 1 },
        },
      });
});